function PerformanceDashboardPage() {
  return <>Performance Dashboard</>;
}

export default PerformanceDashboardPage;
